<div class="dialog-container">
  <div class="dialog-header">
    <p class="title">Create Scenario</p>
    <button type="button" class="btn-close shadow-none" (click)="onClose()" title="Close"></button>
  </div>
  <div class="dialog-content">
    <form [formGroup]="scenarioForm" class="form">
      <div class="form-full-width">
        <label>Scenario Name <span class="text-danger">*</span></label>
        <input pInputText formControlName="scenario_name" placeholder="Ex. Master Plan" (keyup)="checkExistingScenario()" />
        <!-- Error message display -->
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
      </div>
      <div class="form-full-width">
        <label htmlFor="scenario_description">Scenario Description <span class="text-danger">*</span></label>
        <textarea pInputTextarea id="scenario_description" formControlName="scenario_description" rows="3" placeholder="Ex. Scenario created for Branch #3"></textarea>
      </div>
    </form>
  </div>
  <div class="dialog-footer">
    <button class="mdlz-btn disabled:opacity-50 disabled:cursor-not-allowed" (click)="onAddScenario()" [disabled]="scenarioForm.invalid || errorMessage != ''" mat-button>
      Add Scenario
    </button>
    <button class="mdlz-btn-outline" (click)="onClose()" mat-button>Close</button>
  </div>
</div>
